import {EnumTypVysledekDtm} from '../api';

export const enumTypVysledekDtm: string[] = Object.keys(EnumTypVysledekDtm);

export const getEnumTypVysledekDtmCaption = (typ: string | EnumTypVysledekDtm): string => {
    switch (typ) {
        case EnumTypVysledekDtm.EDITACE_NEZPLATNENA:
            return 'Editace zneplatněna';
        case EnumTypVysledekDtm.EDITACE_ZPLATNENA:
            return 'Editace zplatněna';
        case EnumTypVysledekDtm.PODANI_ZAMITNUTO:
            return 'Podání zamítnuto';
        default:
            return `_${typ}`;
    }
};

type EnumStavPrenosDtmProps = {id: EnumTypVysledekDtm; name: string};

export const getEnumTypVysledekDtmItems = (): EnumStavPrenosDtmProps[] => {
    return enumTypVysledekDtm.map((t: EnumTypVysledekDtm): EnumStavPrenosDtmProps => ({id: t, name: getEnumTypVysledekDtmCaption(t)}));
};
